<template>
    <div>
        <v-container fluid>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-combobox
                                v-model="order"
                                :items="orders"
                                :item-text="'OrderID'"
                                :item-value="'OrderID'"
                                label="Select Order"
                                auto-select-first
                            ></v-combobox>
                        </v-col>
                        <v-col cols="12">
                            <v-combobox
                                v-model="types"
                                :items="type"
                                :item-text="'TranType'"
                                :item-value="'TranTypeId'"
                                label="Select Transaction Type"
                                auto-select-first
                            ></v-combobox>
                        </v-col>
                        <v-col sm="6">
                            <v-text-field
                                label="Quantity"
                                v-model="Qty"
                                @blur="CalculateAmount"
                            ></v-text-field>
                        </v-col>
                        <v-col sm="6">
                            <v-text-field
                                @blur="CalculateAmount"
                                label="Rate"
                                v-model="Rate"
                            ></v-text-field>
                        </v-col>
                        <v-col sm="6">
                            <v-text-field
                                disabled
                                label="Amount"
                                v-model="Amount"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="end">
                        <v-btn small @click="newExtraRev()" color="secondary"
                            >Save</v-btn
                        >
                    </v-row>
                </v-container>
            </v-card-text>
        </v-container>
    </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
export default {
    props: ['Add'],
    data: function() {
        return {
            orders: [],
            type: [],
            types: '',
            order: '',
            number: '',
            Qty: '',
            InvId: '',
            PayId: '',
            Amount: '',
            Rate: '',
            momt: ''
        };
    },
    mounted() {
        console.log(this.Add);
        this.loadOrders();
        this.loadTranType();
        this.momt = moment().format('YYYY-MM-DD h:mm:ss');
    },
    methods: {
        CalculateAmount: function() {
            if (this.Add.Type == 1) {
                this.Amount = this.Qty * this.Rate;
            } else {
                this.Amount = this.Qty * this.Rate * -1;
            }
        },
        newExtraRev: function() {
            var parms = {};
            if (this.Add.Type == 1) {
                parms = {
                    ShiftDetail: this.Add.id,
                    LeadOrder: this.order.OrderID,
                    OrderNumber: this.order.OrderID,
                    TranType: this.types.TranTypeId,
                    Quantity: this.Qty,
                    Rate: this.Rate,
                    Amount: this.Amount,
                    TranDate: this.momt
                };
            } else {
                parms = {
                    ShiftDetail: this.Add.id,
                    LeadOrder: this.order.OrderID,
                    OrderNumber: this.order.OrderID,
                    TranType: this.types.TranTypeId,
                    Quantity: this.Qty,
                    Rate: this.Rate,
                    Amount: this.Amount,
                    TranDate: this.momt
                };
            }

            console.log(parms);
            axios
                .post('transaction', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'saved successfully'
                    });
                    this.$store.state.transacting.watch = true;
                    this.$store.state.transacting.dialogAddExt = false;
                })
                .catch(function(error) {
                    console.log(error);

                    this.$store.state.transacting.watch == false;
                });
        },
        loadOrders: function() {
            axios
                .get('order/shift/' + this.Add.id, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.orders = response.data;
                    console.log(this.orders);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadTranType: function() {
            var url = '';
            if (this.Add.Type == 1) {
                url = 'tran-type/extraRev';
            } else {
                url = 'tran-type/extraPay';
            }
            axios
                .get(url, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.type = response.data;
                    console.log(this.type);
                })
                .catch(function(error) {
                    console.log(error);
                });
        }
    }
};
</script>

<style></style>
